module.exports = __webpack_public_path__ + "static/img/color-palette-14.272ee234.svg";